<div class="grocery-item" data-cy="grocery-item" [class.out-of-stock]="!item.inStock">
  <div class="grocery-item-info" tappable (click)="onShowItemDetails()">
    <div [attr.data-src]="item.imageUrl" class="lazy-loading-image not-loaded animated-image">
      <div class="lazy-loading-image-content" [style.backgroundImage]="item.imageUrl ? 'url(' + item.imageUrl + ')' : null"></div>
    </div>

    <div class="item-title" data-cy="grocery-item-name">{{ item.name }}</div>

    <div class="item-stats" *ngIf="item.selectedQuantity > 0">
      <span>{{ item.selectedQuantity * item.price | localCurrency }}</span>
    </div>
  </div>

  <div class="item-discount" *ngIf="item.onSale">
    <span class="item-discount-amount">{{ (item.price - item.retailPrice) / item.retailPrice | percent }}</span>
  </div>

  <!--
    This warning means that the notice period for this
    items is bigger than the time slot shown for the vendor
  -->
  <div class="item-time-slot-warning" *ngIf="noticePeriodWarning">
    <ion-icon src="/assets/custom-icons/b-clock.svg"></ion-icon>
    <span>{{ noticePeriodWarning }}</span>
  </div>

  <ng-container *ngIf="item.inStock">
    <ion-button class="custom-button item-cta" color="grey" (click)="onMaybeAddItem()" *ngIf="!item.selectedQuantity">
      {{ item.price | localCurrency }}
    </ion-button>

    <div class="item-cta" *ngIf="item.selectedQuantity">
      <ion-button class="custom-button decrement" color="grey" (click)="onRemoveItem()">
        <ion-icon slot="icon-only" src="/assets/custom-icons/b-minus.svg"></ion-icon>
      </ion-button>
      <span class="quantity" data-cy="grocery-item-quantity">{{ item.selectedQuantity }}</span>
      <ion-button class="custom-button increment" color="grey" (click)="onMaybeAddItem()">
        <ion-icon slot="icon-only" src="/assets/custom-icons/b-plus.svg"></ion-icon>
      </ion-button>
    </div>
  </ng-container>

  <ng-container *ngIf="!item.inStock">
    <ion-button class="custom-button item-cta" color="grey" disabled>
      {{ "OUT_OF_STOCK" | translate }}
    </ion-button>
  </ng-container>
</div>
